import React from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import TestimonialAreaItem from "./TestimonialAreaItem";
import $ from "jquery";
import { doAnimations } from "../../lib/helpers";
import cn from "classnames";

const TestimonialArea = () => {
  const slick_settings = {
    dots: true,
    infinite: false,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    beforeChange: function (currentSlide, nextSlide) {
      var $animatingElements = $(
        '.single-slider[data-slick-index="' + nextSlide + '"]'
      ).find("[data-animation]");
      doAnimations($animatingElements);
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const testimonialList = [
    {
      title: "Sanne de Vries",
      designation: "Particuliere klant",
      desc: "Mijn oude fauteuils zijn volledig vernieuwd en zien er prachtig uit! De stof en het vakmanschap zijn van topkwaliteit.",
      src: 1, // Vrouw, lichte huid, ongeveer 35 jaar
    },
    {
      title: "Mehmet Kaya",
      designation: "Restaurant eigenaar",
      desc: "Onze stoelen en banken zijn perfect herstoffeerd. Klanten reageren super positief over het nieuwe interieur.",
      src: 2, // Man, lichte tint/mediterrane huid, ongeveer 45 jaar
    },
    {
      title: "Emma Jansen",
      designation: "Interieurarchitect",
      desc: "Zeer professioneel! Samen projecten gedaan waarbij ze perfect konden meedenken in maatwerk en esthetiek.",
      src: 3, // Vrouw, blanke huid, ongeveer 40 jaar
    },
    {
      title: "Lars Bakker",
      designation: "Kantoormanager",
      desc: "Onze vergaderruimtes zijn compleet opnieuw ingericht en de stoffering is duurzaam én stijlvol.",
      src: 4, // Man, lichte huid, ongeveer 50 jaar
    },
    {
      title: "Aïsha el Amrani",
      designation: "Particuliere klant",
      desc: "Mijn vintage bank is prachtig hersteld! De kleuren en afwerking zijn echt beter dan ik had durven dromen.",
      src: 5, // Vrouw, getinte huid, ongeveer 30 jaar
    },
    {
      title: "Jan-Willem de Groot",
      designation: "Hotel eigenaar",
      desc: "Voor ons hotel is de lounge opnieuw gestoffeerd. Zeer hoge kwaliteit en alles netjes volgens afspraak.",
      src: 6, // Man, blanke huid, ongeveer 55 jaar
    },
  ];

  return (
    <section className="testimonial-area pt-110 pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-60">
              <span className="sub-title">Klantenervaringen</span>
              <h2 className="title">Wat Onze Klanten Zeggen</h2>
            </div>
          </div>
        </div>

        <div className="testimonial-item-wrap">
          <div className="row testimonial-active">
            <SlickSlider settings={slick_settings}>
              {testimonialList.map((x, index) => (
                <div
                  key={index}
                  className={cn(
                    "col-lg-3",
                    index % 2 === 0 && "testimonial-item-wrap-item-even"
                  )}
                >
                  <TestimonialAreaItem item={x} />
                </div>
              ))}
            </SlickSlider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialArea;
